import React from 'react';

import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';
import { useNavigate } from 'react-router-dom';

import useScreenSize from '@/hooks/useScreenSize';
import { BreadcrumbItem } from '@/services/types/Breadcrumb';

import styles from './styles.module.css';

export const GoBackArrowBtn: React.FC<{
  parent?: BreadcrumbItem;
  goBack?: number;
  alternative?: boolean;
  onBack?: () => void;
}> = ({ parent, goBack, alternative, onBack }) => {
  const navigate = useNavigate();
  const { windowWidth } = useScreenSize();

  const handleGoBack = () => {
    if (onBack) {
      onBack();
    } else if (goBack) {
      navigate(goBack);
    } else {
      navigate(parent?.path || '/', { state: { key: parent?.key } });
    }
  };

  return (
    <button
      className={`${alternative ? styles.alternativeBreadcrumb : styles.goBackArrowBtn}`}
      onClick={handleGoBack}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleGoBack();
        }
      }}
      tabIndex={0}
      aria-label="Retour"
    >
      <MtxIcon name="arrow-left-big" size={windowWidth < 599 ? 24 : 32} />
    </button>
  );
};
